(function () {

  'use strict';

  /* =========================================================
   * LOAD ONCE
   * ========================================================= */

  if (window.__libraCombinedCartScriptLoaded) {
    return;
  }

  window.__libraCombinedCartScriptLoaded = true;
  window.__libraCartOperationRunning = false;

  var ROOT =
    (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';


  /* =========================================================
   * HELPERS
   * ========================================================= */

  function getCartDrawer() {

    var selectors = [
      'cart-drawer',
      '#CartDrawer',
      '.cart-drawer',
      '[data-cart-drawer]',
      '.drawer--cart'
    ];

    for (var i = 0; i < selectors.length; i++) {
      var drawer = document.querySelector(selectors[i]);
      if (drawer) return drawer;
    }

    return null;
  }


  /*
   * Sections the theme wants re-rendered after a cart change
   * (Dawn: cart-drawer + cart-icon-bubble).
   */
  function getSectionIds(drawer) {

    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      return drawer.getSectionsToRender().map(function (section) {
        return section.id;
      });
    }

    return ['cart-drawer', 'cart-icon-bubble'];
  }


  async function postJSON(url, body) {

    var response = await fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(body)
    });

    var data = await response.json().catch(function () {
      return {};
    });

    if (!response.ok) {
      throw new Error(data.description || data.message || 'Cart request failed.');
    }

    return data;
  }


  /*
   * Fresh section HTML via Shopify's Section Rendering API.
   */
  async function fetchSections(sectionIds) {

    var url =
      window.location.pathname +
      '?sections=' + sectionIds.join(',') +
      '&_=' + Date.now();

    var response = await fetch(url, {
      credentials: 'same-origin',
      cache: 'no-store'
    });

    if (!response.ok) {
      throw new Error('Unable to load cart sections.');
    }

    return response.json();
  }


  function hasAllSections(sections, sectionIds) {

    if (!sections) return false;

    return sectionIds.every(function (id) {
      return !!sections[id];
    });
  }


  function getInnerHTML(html, selector) {

    var doc = new DOMParser().parseFromString(html, 'text/html');
    var element = doc.querySelector(selector);

    return element ? element.innerHTML : null;
  }


  /* =========================================================
   * RENDER + OPEN DRAWER
   * ========================================================= */

  /*
   * Fallback for themes without renderContents().
   */
  function renderSectionsManually(drawer, sections) {

    Object.keys(sections).forEach(function (id) {

      var html = sections[id];
      if (!html) return;

      if (id === 'cart-drawer') {

        var liveInner = document.querySelector('#CartDrawer');
        var newInner = getInnerHTML(html, '#CartDrawer');

        if (liveInner && newInner !== null && liveInner !== drawer) {
          liveInner.innerHTML = newInner;
        } else {
          var newDrawerHTML = getInnerHTML(html, 'cart-drawer');
          if (newDrawerHTML !== null) drawer.innerHTML = newDrawerHTML;
        }

        return;
      }

      var target =
        document.getElementById(id) ||
        document.getElementById('shopify-section-' + id);

      var content = getInnerHTML(html, '.shopify-section');

      if (target && content !== null) {
        target.innerHTML = content;
      }
    });
  }


  function openDrawerFallback(drawer) {

    if (typeof drawer.open === 'function') {
      drawer.open();
      return;
    }

    document.dispatchEvent(new CustomEvent('cart:open'));

    drawer.classList.add('is-open', 'drawer--is-open', 'active');
    drawer.setAttribute('aria-hidden', 'false');
  }


  function publishCartUpdate(state) {

    try {
      if (
        typeof publish === 'function' &&
        typeof PUB_SUB_EVENTS !== 'undefined'
      ) {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'libra-cart',
          cartData: state
        });
      }
    } catch (error) {
      /* theme has no pub/sub, ignore */
    }
  }


  /*
   * Content is rendered FIRST, the drawer opens AFTER.
   */
  function showCart(drawer, state) {

    // Removes the "Your cart is empty" state
    drawer.classList.remove('is-empty');

    if (typeof drawer.renderContents === 'function') {

      // Theme's own method: replaces HTML, re-binds events, then opens
      drawer.renderContents(state);

    } else {

      renderSectionsManually(drawer, state.sections || {});

      requestAnimationFrame(function () {
        openDrawerFallback(drawer);
      });
    }

    publishCartUpdate(state);
  }


  /* =========================================================
   * DISCOUNT
   * ========================================================= */

  async function applyDiscount(discountCode) {

    var code = (discountCode || '').trim();
    if (!code) return null;

    try {
      return await postJSON(ROOT + 'cart/update.js', { discount: code });
    } catch (error) {
      console.warn('Discount could not be applied:', error);
      return null;
    }
  }


  /* =========================================================
   * COMPLETE CART FLOW
   *
   * ADD (+ get drawer HTML in the same request)
   * ↓
   * DISCOUNT (optional, then fresh drawer HTML)
   * ↓
   * RENDER DRAWER
   * ↓
   * OPEN DRAWER
   * ========================================================= */

  async function completeCartFlow(items, discountCode) {

    if (window.__libraCartOperationRunning) {
      console.warn('Another cart operation is already running.');
      return false;
    }

    window.__libraCartOperationRunning = true;

    try {

      var drawer = getCartDrawer();
      var sectionIds = getSectionIds(drawer);

      // STEP 1: add products and request updated drawer HTML
      var result = await postJSON(ROOT + 'cart/add.js', {
        items: items,
        sections: sectionIds.join(','),
        sections_url: window.location.pathname
      });

      console.log('Products added:', result);

      // STEP 2: discount (totals change, so reload sections)
      if (discountCode && discountCode.trim()) {
        await applyDiscount(discountCode);
        result.sections = await fetchSections(sectionIds);
      }

      // No drawer on this theme/setting: go to cart page
      if (!drawer) {
        window.location.href = ROOT + 'cart';
        return true;
      }

      // Make sure we have every section the drawer needs
      if (!hasAllSections(result.sections, sectionIds)) {
        result.sections = await fetchSections(sectionIds);
      }

      var firstItem = result.items && result.items[0];

      // STEP 3 + 4: render, then open
      showCart(drawer, {
        id: firstItem ? firstItem.variant_id : null,
        items: result.items,
        sections: result.sections
      });

      return true;

    } finally {

      window.__libraCartOperationRunning = false;
    }
  }


  function setLoading(button, isLoading) {

    if (!button) return;

    button.disabled = isLoading;
    button.classList.toggle('is-loading', isLoading);
    button.setAttribute('aria-busy', isLoading ? 'true' : 'false');
  }


  /* =========================================================
   * PRODUCT ADD-ONS
   * ========================================================= */

  function resetAddOnSelections(block) {

    if (!block) return;

    block.querySelectorAll('[data-addon].is-selected').forEach(function (item) {

      item.classList.remove('is-selected');

      var button = item.querySelector('[data-addon-button]');
      if (button) button.textContent = '+';
    });
  }


  function getCurrentProductVariantId(block) {

    /*
     * Main product form only. Never a "You May Also Like" card.
     */
    var input =
      document.querySelector('product-form form[action*="/cart/add"]:not(.ymal-card__form) input[name="id"]') ||
      document.querySelector('form[action*="/cart/add"]:not(.ymal-card__form) input[name="id"]');

    if (input && input.value) {
      return Number(input.value);
    }

    if (block && block.dataset.currentVariantId) {
      return Number(block.dataset.currentVariantId);
    }

    return null;
  }


  function initProductAddOns(block) {

    if (!block) return;

    if (block.dataset.addonsInitialized === 'true') return;
    block.dataset.addonsInitialized = 'true';

    var submitButton = block.querySelector('[data-add-ons-submit]');
    var discountCode = block.dataset.discountCode;

    /*
     * SELECT / UNSELECT ADD-ONS
     */
    block.querySelectorAll('[data-addon]').forEach(function (item) {

      var button = item.querySelector('[data-addon-button]');
      if (!button) return;

      button.addEventListener('click', function (event) {

        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        item.classList.toggle('is-selected');

        button.textContent = item.classList.contains('is-selected') ? '✓' : '+';
      });
    });

    if (!submitButton) return;

    /*
     * SUBMIT ADD-ONS
     */
    submitButton.addEventListener('click', async function (event) {

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      if (submitButton.disabled) return;

      if (window.__libraCartOperationRunning) {
        console.warn('Another cart operation is already running.');
        return;
      }

      var currentVariantId = getCurrentProductVariantId(block);

      if (!currentVariantId) {
        console.error('Current product variant could not be found.');
        return;
      }

      var items = [{
        id: currentVariantId,
        quantity: 1
      }];

      block.querySelectorAll('[data-addon].is-selected').forEach(function (item) {

        var variantId = item.dataset.variantId;
        if (!variantId) return;

        items.push({
          id: Number(variantId),
          quantity: 1,
          properties: {
            '_Add-on': 'true'
          }
        });
      });

      setLoading(submitButton, true);

      try {

        var success = await completeCartFlow(items, discountCode);

        if (success) {
          resetAddOnSelections(block);
        }

      } catch (error) {

        console.error('Product Add-ons Error:', error);

      } finally {

        setLoading(submitButton, false);
      }
    });
  }


  /* =========================================================
   * YOU MAY ALSO LIKE - SLIDER
   * ========================================================= */

  function initYouMayAlsoLike(section) {

    if (!section) return;

    if (section.dataset.ymalInitialized === 'true') return;
    section.dataset.ymalInitialized = 'true';

    var slider = section.querySelector('[data-ymal-slider]');
    if (!slider) return;

    var autoplayDelay = 3000;
    var autoplayTimer = null;
    var resumeTimer = null;

    function getScrollAmount() {

      var card = slider.querySelector('.ymal-card');
      if (!card) return slider.clientWidth;

      var styles = window.getComputedStyle(slider);
      var gap = parseFloat(styles.columnGap || styles.gap) || 0;

      return card.getBoundingClientRect().width + gap;
    }

    function canSlide() {
      return slider.scrollWidth > slider.clientWidth + 5;
    }

    function moveNext() {

      if (!canSlide()) return;

      var maxScroll = slider.scrollWidth - slider.clientWidth;

      if (slider.scrollLeft >= maxScroll - 5) {
        slider.scrollTo({ left: 0, behavior: 'smooth' });
      } else {
        slider.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
      }
    }

    function stopAutoplay() {
      if (autoplayTimer) {
        clearInterval(autoplayTimer);
        autoplayTimer = null;
      }
    }

    function startAutoplay() {
      stopAutoplay();
      if (!canSlide()) return;
      autoplayTimer = setInterval(moveNext, autoplayDelay);
    }

    function resumeAutoplay() {
      if (resumeTimer) clearTimeout(resumeTimer);
      resumeTimer = setTimeout(startAutoplay, 2500);
    }

    slider.addEventListener('mouseenter', stopAutoplay);
    slider.addEventListener('mouseleave', startAutoplay);
    slider.addEventListener('touchstart', stopAutoplay, { passive: true });
    slider.addEventListener('touchend', resumeAutoplay, { passive: true });
    slider.addEventListener('pointerdown', stopAutoplay);
    slider.addEventListener('pointerup', resumeAutoplay);
    window.addEventListener('resize', startAutoplay);

    startAutoplay();
  }


  /* =========================================================
   * YOU MAY ALSO LIKE - ADD TO CART
   *
   * One delegated listener: works for every card, including
   * sections reloaded in the theme editor.
   * ========================================================= */

  document.addEventListener('submit', async function (event) {

    var form = event.target;

    if (!form || !form.classList || !form.classList.contains('ymal-card__form')) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    var button =
      form.querySelector('[data-ymal-add-to-cart]') ||
      form.querySelector('[type="submit"]');

    if (!button || button.disabled) return;

    var idInput = form.querySelector('input[name="id"]');
    var qtyInput = form.querySelector('input[name="quantity"]');

    if (!idInput || !idInput.value) {
      console.error('You May Also Like: variant id missing.');
      return;
    }

    var items = [{
      id: Number(idInput.value),
      quantity: Number(qtyInput && qtyInput.value) || 1
    }];

    setLoading(button, true);

    try {

      await completeCartFlow(items, null);

    } catch (error) {

      console.error('You May Also Like Error:', error);

    } finally {

      setLoading(button, false);
    }

  }, true);


  /* =========================================================
   * INITIALIZE
   * ========================================================= */

  function initialize() {

    document.querySelectorAll('[data-add-ons]').forEach(initProductAddOns);
    document.querySelectorAll('.you-may-also-like-section').forEach(initYouMayAlsoLike);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize);
  } else {
    initialize();
  }


  /* =========================================================
   * SHOPIFY THEME EDITOR
   * ========================================================= */

  document.addEventListener('shopify:section:load', function (event) {

    var target = event.target;
    if (!target || !target.querySelectorAll) return;

    target.querySelectorAll('[data-add-ons]').forEach(initProductAddOns);
    target.querySelectorAll('.you-may-also-like-section').forEach(initYouMayAlsoLike);

    if (target.classList && target.classList.contains('you-may-also-like-section')) {
      initYouMayAlsoLike(target);
    }
  });

})();



// Review Hide CSS

